<!-- <template>
  <router-view/>
</template>

<style>

</style>
<script>
require('@/assets/style.css')
</script> -->

<template>
  <router-view />
</template>

<script setup>
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useUserStore } from '@/store/user'
import '@/assets/style.css'

const router = useRouter()
const userStore = useUserStore()

onMounted(() => {
  setTimeout(() => {
    ///console.log('hai vishnu') 
    localStorage.removeItem('authToken')
    userStore.authToken = null
    router.push('/') 
  }, 1 * 60 * 60 * 1000) // 1hr
})
</script>

<style>
</style>
